if (!customElements.get('knotz-bedding-builder')) customElements.define('knotz-bedding-builder', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.config = JSON.parse(this.querySelector('[data-config]').textContent);
    this.copy = this.config.copy;
    this.base = this.config.base;
    this.extras = this.config.extras;
    this.preview = this.config.preview || [];
    if (this.config.previewOnly && this.preview.length) {
      this.base = this.preview[4];
      this.querySelector('[data-title]').textContent = this.base.title;
      const image = this.querySelector('[data-main-image]');
      if (image) { image.src = this.base.image; image.alt = this.base.title; image.removeAttribute('srcset'); }
      this.querySelector('.kb-thumbs')?.remove();
    }
    if (!this.base?.variants?.length && this.preview.length) this.base = this.preview[4];
    this.extras = this.extras.map((p, i) => p?.variants?.length ? p : this.preview.find(v => v.handle === this.config.handles[i])).filter(Boolean);
    this.selected = new Map();
    this.manual = new Set();
    this.busy = false;
    this.form = this.querySelector('form');
    this.baseSelect = this.querySelector('[data-base-size]');
    this.addons = this.querySelector('[data-addons]');
    this.money = n => new Intl.NumberFormat(this.config.locale, { style: 'currency', currency: this.config.currency, maximumFractionDigits: 0 }).format(n / 100);
    this.render();
    this.addEventListener('change', e => this.change(e));
    this.addEventListener('click', e => {
      const size = e.target.closest('[data-variant-choice]');
      if (size) { this.baseSelect.value = size.dataset.variantChoice; this.syncSizes(); this.update(); }
      const thumb = e.target.closest('[data-image]');
      if (thumb) { const main = this.querySelector('[data-main-image]'); main.src = thumb.dataset.image; main.removeAttribute('srcset'); }
    });
    this.form.addEventListener('submit', e => { e.preventDefault(); this.submit(); });
    this.update();
  }
  text(tag, value, parent, attrs = {}) {
    const el = document.createElement(tag);
    el.textContent = value;
    for (const [k, v] of Object.entries(attrs)) el.setAttribute(k, v);
    parent.append(el);
    return el;
  }
  render() {
    if (!this.base) { this.querySelector('[data-error]').textContent = this.copy.unavailable; return; }
    const title = this.querySelector('[data-title]');
    if (!title.textContent.trim()) title.textContent = this.base.title;
    const image = this.querySelector('[data-main-image]');
    if (!image && this.base.image) {
      const img = document.createElement('img'); img.src = this.base.image; img.alt = this.base.title; img.width = 1200; img.height = 1200; img.dataset.mainImage = '';
      this.querySelector('[data-gallery]').prepend(img);
    }
    this.base.variants.forEach(v => {
      const opt = this.text('option', v.title + (v.available ? '' : ' — ' + this.copy.soldOut), this.baseSelect, { value: v.id });
      opt.selected = String(v.id) === String(this.config.selectedId);
      const choices = this.querySelector('[data-size-buttons]');
      if (choices) this.text('button', v.title, choices, { type: 'button', 'data-variant-choice': String(v.id), 'aria-pressed': 'false' });
    });
    this.extras.forEach(p => {
      const row = this.text('article', '', this.addons, { class: 'kb-addon', 'data-product': p.handle });
      const top = this.text('label', '', row, { class: 'kb-addon__top' });
      const toggle = document.createElement('input'); toggle.type = 'checkbox'; toggle.dataset.toggle = p.handle; top.append(toggle);
      if (p.image) { const img = document.createElement('img'); img.src = p.image; img.alt = ''; img.width = 72; img.height = 72; img.loading = 'lazy'; top.append(img); }
      this.text('span', p.title, top);
      this.text('span', '', top, { 'data-price': '', class: 'kb-addon__price' });
      const controls = this.text('div', '', row, { class: 'kb-addon__controls' });
      p.options.forEach((option, index) => {
        const label = this.text('label', option.name.trim(), controls);
        const select = this.text('select', '', label, { 'data-option': String(index), 'aria-label': p.title + ' — ' + option.name.trim() });
        option.values.forEach(value => this.text('option', value, select, { value }));
      });
      const qtyLabel = this.text('label', this.copy.quantity, controls);
      const qty = this.text('select', '', qtyLabel, { 'data-quantity': '', 'aria-label': p.title + ' — ' + this.copy.quantity });
      for (let n = 1; n <= 4; n++) this.text('option', String(n), qty, { value: String(n) });
      if (p.handle === 'lumbar-cushion') this.text('p', this.copy.lumbarGuide, controls, { class: 'kb-hint' });
      if (p.handle === 'flower-cushion') this.text('p', this.copy.flowerGuide, controls, { class: 'kb-hint' });
      const initial = (p.handle === 'rose-coffee-room-styling-set' ? p.variants.find(v => v.available && /cushions only/i.test(v.title)) : null) || p.variants.find(v => v.available && v.options.some(o => o.toLowerCase() === 'ivory')) || p.variants.find(v => v.available) || p.variants[0];
      [...controls.querySelectorAll('[data-option]')].forEach((s, i) => { s.value = initial.options[i]; });
    });
    this.syncSizes();
  }
  baseVariant() { return this.base?.variants.find(v => String(v.id) === this.baseSelect.value); }
  syncSizes() {
    const king = /king/i.test(this.baseVariant()?.title || '');
    for (const p of this.extras) {
      if (this.manual.has(p.handle)) continue;
      const row = this.addons.querySelector('[data-product="' + p.handle + '"]');
      if (p.handle === 'lumbar-cushion' || p.handle === 'ivory-cotton-flat-sheet' || p.handle === 'knotted-bed-runner') {
        const index = p.options.findIndex(o => /size/i.test(o.name));
        const select = row.querySelector('[data-option="' + index + '"]');
        const target = p.options[index]?.values.find(v => p.handle === 'lumbar-cushion' ? (king ? /48/.test(v) : /36/.test(v)) : (king ? /king/i.test(v) : /queen/i.test(v)));
        if (select && target) select.value = target;
      }
    }
  }
  change(e) {
    if (e.target.matches('[data-shopping-mode]')) {
      const setOnly = e.target.value === 'set';
      this.querySelector('[data-extras-panel]').hidden = setOnly;
      if (setOnly) this.addons.querySelectorAll('[data-toggle]').forEach(input => { input.checked = false; });
    }
    if (e.target === this.baseSelect) this.syncSizes();
    const row = e.target.closest('[data-product]');
    if (row && e.target.matches('[data-option]')) {
      const p = this.extras.find(p => p.handle === row.dataset.product);
      if (/size/i.test(p.options[Number(e.target.dataset.option)].name)) this.manual.add(p.handle);
    }
    this.update();
  }
  lines() {
    const base = this.baseVariant();
    const count = Math.max(1, Math.min(20, Number(this.querySelector('[data-set-quantity]').value) || 1));
    const lines = base ? [{ product: this.base, variant: base, quantity: count }] : [];
    this.selected.forEach(item => lines.push({ ...item, quantity: item.quantity * count }));
    return lines;
  }
  update() {
    this.selected.clear();
    for (const p of this.extras) {
      const row = this.addons.querySelector('[data-product="' + p.handle + '"]');
      const selections = [...row.querySelectorAll('[data-option]')].map(s => s.value);
      const variant = p.variants.find(v => v.options.every((o, i) => o === selections[i]));
      const toggle = row.querySelector('[data-toggle]');
      const price = row.querySelector('[data-price]');
      price.textContent = variant ? '+' + this.money(variant.price) + (variant.available ? '' : ' · ' + this.copy.soldOut) : this.copy.unavailable;
      row.dataset.invalid = String(!variant?.available);
      row.querySelector('.kb-addon__controls').hidden = !toggle.checked;
      if (toggle.checked) this.selected.set(p.handle, { product: p, variant, quantity: Number(row.querySelector('[data-quantity]').value) });
    }
    const lines = this.lines();
    const invalid = !lines.length || lines.some(l => !l.variant?.available);
    const draft = lines.some(l => !l.product.purchasable);
    const total = lines.reduce((n, l) => n + (l.variant?.price || 0) * l.quantity, 0);
    this.querySelector('[data-total]').textContent = this.money(total);
    const totalWrap = this.querySelector('[data-total-wrap]');
    if (totalWrap) totalWrap.hidden = false;
    const count = this.querySelector('[data-extra-count]');
    if (count) count.textContent = this.selected.size ? '(' + this.selected.size + ')' : '+';
    this.querySelector('[data-base-price]').textContent = this.money(this.baseVariant()?.price || 0);
    const button = this.querySelector('[data-review-button]');
    button.disabled = invalid || draft || this.busy;
    button.textContent = invalid ? this.copy.soldOut : draft ? this.copy.launch : this.busy ? this.copy.adding : this.copy.add + ' · ' + this.money(total);
    this.querySelectorAll('[data-variant-choice]').forEach(button => { button.setAttribute('aria-pressed', String(button.dataset.variantChoice === this.baseSelect.value)); });
    const order = this.querySelector('[data-order-lines]');
    if (order) { order.replaceChildren(); for (const line of lines) if (line.variant) this.text('li', line.quantity + ' × ' + (line.product === this.base ? this.copy.baseSet : line.product.title) + ' · ' + line.variant.title + ' — ' + this.money(line.variant.price * line.quantity), order); }
    this.querySelector('[data-launch-note]').hidden = !draft;
  }
  payload(group) {
    return { items: this.lines().map(l => ({ id: Number(l.variant.id), quantity: l.quantity, properties: { 'Bedding set': this.base.title, 'Bed size': this.baseVariant().title, '_knotz_set': group, '_knotz_role': l.product.id === this.base.id ? 'base' : 'add-on' } })) };
  }
  async submit() {
    if (this.busy || !this.lines().length || this.lines().some(l => !l.variant?.available)) return;
    if (this.lines().some(l => !l.product.purchasable)) return;
    this.busy = true;
    this.querySelector('[data-error]').textContent = '';
    const group = 'kb-' + (globalThis.crypto?.randomUUID?.() || Date.now() + '-' + Math.random().toString(36).slice(2));
    this.update();
    try {
      const response = await fetch(this.config.root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(this.payload(group)) });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || this.copy.failed);
      window.location.assign(this.config.cart);
    } catch (error) {
      this.querySelector('[data-error]').textContent = error.message + ' ' + this.copy.checkCart;
      this.querySelector('[data-cart-link]').hidden = false;
      this.querySelector('[data-review-button]').disabled = true;
      this.querySelector('[data-review-button]').textContent = this.copy.checkCart;
    }
  }
});

